import { registerComponent } from '@gig/magic-common';
import RealityCheckModalComponent from './reality-check-modal.vue.js';

var RealityCheckModal = registerComponent(RealityCheckModalComponent);

export { RealityCheckModal };
